function padZero(n) {
  return n > 9 ? n : "0" + n;
}
//
export function formatSeconds(msd) {
  var time = msd;
  if (time > 60 && time < 60 * 60) {
    time =
      padZero(parseInt(time / 60.0, 10)) +
      ":" +
      padZero(
        parseInt(
          (parseFloat(time / 60.0, 10, 10) - parseInt(time / 60.0, 10)) * 60,
          10
        )
      );
  } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
    time =
      padZero(parseInt(time / 3600.0, 10)) +
      ":" +
      padZero(
        parseInt(
          (parseFloat(time / 3600.0) - parseInt(time / 3600.0, 10), 10) * 60,
          10
        )
      ) +
      ":" +
      padZero(
        parseInt(
          (parseFloat(
            (parseFloat(time / 3600.0, 10) - parseInt(time / 3600.0, 10)) * 60
          ) -
            parseInt(
              (parseFloat(time / 3600.0, 10) - parseInt(time / 3600.0, 10)) *
                60,
              10
            ),
          10) * 60,
          10
        )
      );
  } else if (time >= 60 * 60 * 24) {
    time =
      parseInt(time / 3600.0 / 24, 10) +
      "天" +
      parseInt(
        (parseFloat(time / 3600.0 / 24, 10) -
          parseInt(time / 3600.0 / 24, 10)) *
          24,
        10
      ) +
      "小时" +
      parseInt(
        (parseFloat(time / 3600.0, 10, 10) - parseInt(time / 3600.0, 10)) * 60,
        10
      ) +
      "分钟" +
      parseInt(
        (parseFloat(
          (parseFloat(time / 3600.0, 10) - parseInt(time / 3600.0, 10), 10) * 60
        ) -
          parseInt(
            (parseFloat(time / 3600.0, 10) - parseInt(time / 3600.0, 10)) * 60,
            10
          )) *
          60,
        10
      ) +
      "秒";
  } else {
    time = "00:" + padZero(parseInt(time, 10));
  }
  return time;
}



// WEBPACK FOOTER //
// ./src/utils/common.js